<p class="description">
  <span class="fw-bold primary-text">{{ 'hint_l' | translate }}: </span>
  <span class="primary-text">{{ 'user_edit_desc_no_hint' | translate }}</span>
  <a (click)="goToConcerns.emit()" href="#" routerLink="/tickets/requests">{{
    'concern_l' | translate
  }}</a
  >.
</p>

<h5>{{ 'user_edit_l' | translate }}</h5>

@for (selection of config(); track selection.changeType) {
  <label class="im:radio-label">
    <input
      [value]="selection"
      class="im:radio-input me-2"
      type="radio"
      name="selection"
      formControlName="selection"
    />
    {{ translateKeys[selection.changeType] | translate
    }}{{ selection.requestType === MasterDataChangeRequestType.TICKET ? '*' : '' }}
  </label>
}
@if (activeHint()) {
  <p class="description primary-text mt-4">* {{ 'edit_profile_ticket_hint_l' | translate }}</p>
}
